module.exports = __webpack_public_path__ + "static/media/knee_rot.2305790d.png";